import React from "react";
import PropTypes from "prop-types";
import ReactJWPlayer from "react-jw-player";

const displayName = "ReactJWPlayerContainer";
const defaultProps = {};

const propTypes = {
  file: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  i18nLangCode: PropTypes.string.isRequired,
  i18nLabels: PropTypes.string.isRequired,
  videoSubtitlesEnabledLanguages: PropTypes.string.isRequired,
};

class ReactJWPlayerContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      videoTitle: props.title,
    };

    this.onAdPlay = this.onAdPlay.bind(this);
    this.onReady = this.onReady.bind(this);
    this.onVideoLoad = this.onVideoLoad.bind(this);

    // Activate subtitles only if needed
    let trackObj = {};
    if (props.videoSubtitlesEnabledLanguages.includes(props.i18nLangCode)) {
      trackObj = {
        kind: "captions",
        file: props.captions,
        label: props.i18nLabels.languageNameLabel,
        default: false,
      };
    }

    this.playlist = [
      {
        file: props.file,
        image: props.image,
        tracks: [trackObj],
      },
    ];

    this.i18nLabels = props.i18nLabels;
    this.i18nLangCode = props.i18nLangCode;

    // each instance of <ReactJWPlayer> needs a unique id.
    // we randomly generate it here and assign to the container instance.
    this.playerId = `player_${Date.now()}`;
  }

  onReady(event) {
    // interact with JW Player API here
    const player = window.jwplayer(this.playerId);
  }
  onAdPlay(event) {
    // track the ad play here
  }
  onVideoLoad(event) {
    this.setState({
      videoTitle: event.item.description, // this only works with json feeds!
    });
  }
  render() {
    return (
      <div className="react-jw-player-container">
        <ReactJWPlayer
          playlist={this.playlist}
          customProps={{
            width: "100%",
            aspectratio: "16:9",
            title: this.state.videoTitle,
            image: this.image,
            intl: {
              [this.i18nLangCode]: {
                rewind: this.i18nLabels.rewindLabel,
                pipIcon: this.i18nLabels.pipIconLabel,
                unmute: this.i18nLabels.unmuteLabel,
                mute: this.i18nLabels.muteLabel,
                volume: this.i18nLabels.volumeLabel,
                volumeSlider: this.i18nLabels.volumeSliderLabel,
                play: this.i18nLabels.playLabel,
                pause: this.i18nLabels.pauseLabel,
                settings: this.i18nLabels.settingsLabel,
                cc: this.i18nLabels.ccLabel,
                off: this.i18nLabels.offLabel,
                fullscreen: this.i18nLabels.fullscreenLabel,
                exitFullscreen: this.i18nLabels.exitFullscreenLabel,
                reset: this.i18nLabels.resetLabel,
                captionsStyles: {
                  color: this.i18nLabels.captionsColorLabel,
                  backgroundColor: this.i18nLabels.captionsBgColorLabel,
                  backgroundOpacity: this.i18nLabels.captionsBgOpacityLabel,
                  black: this.i18nLabels.captionsBlackLabel,
                  blue: this.i18nLabels.captionsBlueLabel,
                  characterEdge: this.i18nLabels.captionsCharacterEdgeLabel,
                  cyan: this.i18nLabels.captionsCyanLabel,
                  depressed: this.i18nLabels.captionsDepressedLabel,
                  disabled: this.i18nLabels.captionsDisabledLabel,
                  enabled: this.i18nLabels.captionsEnabledLabel,
                  dropShadow: this.i18nLabels.captionsDropShadowLabel,
                  fontFamily: this.i18nLabels.captionsFontFamilyLabel,
                  fontOpacity: this.i18nLabels.captionsFontOpacityLabel,
                  fontSize: this.i18nLabels.captionsFontSizeLabel,
                  green: this.i18nLabels.captionsGreenLabel,
                  magenta: this.i18nLabels.captionsMagentaLabel,
                  none: this.i18nLabels.captionsNoneLabel,
                  raised: this.i18nLabels.captionsRaisedLabel,
                  red: this.i18nLabels.captionsRedLabel,
                  reset: this.i18nLabels.captionsResetLabel,
                  subtitleSettings:
                    this.i18nLabels.captionsSubtitleSettingsLabel,
                  uniform: this.i18nLabels.captionsUniformLabel,
                  white: this.i18nLabels.captionsWhiteLabel,
                  windowColor: this.i18nLabels.captionsWindowColorLabel,
                  windowOpacity: this.i18nLabels.captionsWindowOpacityLabel,
                  yellow: this.i18nLabels.captionsUserYellowLabel,
                  userFontScale: this.i18nLabels.captionsUserFontScaleLabel,
                  edgeStyle: this.i18nLabels.captionsEdgeStyleLabel,
                },
              },
            },
          }}
          onAdPlay={this.onAdPlay}
          onReady={this.onReady}
          onVideoLoad={this.onVideoLoad}
          playerId={this.playerId} // bring in the randomly generated playerId
          playerScript="/js/jwplayer.js"
        />
      </div>
    );
  }
}

ReactJWPlayerContainer.propTypes = propTypes;
ReactJWPlayerContainer.defaultProps = defaultProps;
ReactJWPlayerContainer.displayName = displayName;
export default ReactJWPlayerContainer;
